/**
 * Retrieves the dist name to use for Sentry.
 *
 * @returns The dist name to use when configuring Sentry.
 */
export function getDistName() {
  // Prefer REF_NAME which is the release version or branch name
  // return process.env.REF_NAME || process.env.AWS_BRANCH || process.env.SENTRY_RELEASE
  return process.env.NEXT_PUBLIC_ENVIRONMENT + '-' + process.env.AWS_COMMIT_ID
}

export function getSentryRelease() {
  return process.env.REF_NAME || process.env.AWS_BRANCH || process.env.SENTRY_RELEASE
}
